import { gql, useMutation } from "@apollo/client";
import { CreateWithdrawalMutationMutation, CreateWithdrawalMutationMutationVariables } from "../../../../schemaTypes";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";
import { ReactElement } from "react";
import { normalizeErrors } from "../../../../utils/normalizeErrors";

export const createWithdrawalMutation = gql`
  mutation CreateWithdrawalMutation(
    $input: CreateWithdrawalInput!
  ) {
    createWithdrawal(
      input: $input
      ) {
      errors {
        path
        message
      }
      message
      data {
        id
        account_number
        bank_code
        full_name
        currency
        debit_currency
        amount
        fee
        status
        reference
        narration
        complete_message
        requires_approval
        is_approved
        bank_name
        created_at
      }
    }
  }
`;

interface Props {
  children: (
    data: {
      submitCreateWithdrawal: (
        values: CreateWithdrawalMutationMutationVariables
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      createWithdrawalData: any | null; 
    }
  ) => ReactElement | null;
}

export const CreateWithdrawalController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    CreateWithdrawalMutationMutation,
    CreateWithdrawalMutationMutationVariables
  >(
    createWithdrawalMutation
  );

  const submitCreateWithdrawal = async (values: CreateWithdrawalMutationMutationVariables) => {
    const { data: {createWithdrawal} }:any = await mutate({ variables: values });

    if (createWithdrawal?.errors) {
      return {error: normalizeErrors(createWithdrawal.errors), createWithdrawal: null};
    }

    return {
      error: null,
      createWithdrawal
    };
  };

  const message = data?.createWithdrawal?.message || null;

  return children({
    submitCreateWithdrawal,
    loading,
    error,
    message,
    createWithdrawalData: data,
  });
};